import { z } from "zod";
import { HOME_FRAMES } from "@amber/application/contracts";
import { searchParam } from "@amber/ui";

export const homeSearchSchema = z.object({ frame: searchParam(z.enum(HOME_FRAMES)) });
